import { Navigate } from "react-router-dom";
import { useStore } from "../app/stores/store";

const CheckLoginStatus = () => {
  const {userStore: {isLoggedIn}} = useStore();
  return <Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />;
};

export default CheckLoginStatus;
